export default __webpack_public_path__ + "static/media/Legend7.97e3f45a.jpeg";